import { SelectOption } from '../components/molecules/form-elements/FormSelectField';

export const PERMISSIONS = {
  defaultSuperAdminRole: 'default-super-admin-role',
  defaultAdminRole: 'default-administrator-role',
  defaultManagerRole: 'default-manager-role',
  defaultAgentRole: 'default-agent-role',
  defaultTraderRole: 'default-trader-role',
  defaultTechSupportRole: 'default-tech-support-role',
  defaultPlayerRole: 'default-roles-sportsbook-end-users',
} as const;

export type Permission = keyof typeof PERMISSIONS;

export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  AGENT: 'Agent',
  TRADER: 'Trader',
  TECH_SUPPORT: 'Tech Support',
  PLAYER: 'Player',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];
export type SelectableUserRole = Extract<
  UserRole,
  typeof USER_ROLES.PLAYER | typeof USER_ROLES.AGENT | typeof USER_ROLES.MANAGER
>;

export const ROLE_PERMISSION_MAP: { role: UserRole; permission: Permission }[] = [
  { role: USER_ROLES.SUPER_ADMIN, permission: 'defaultSuperAdminRole' },
  { role: USER_ROLES.ADMIN, permission: 'defaultAdminRole' },
  { role: USER_ROLES.MANAGER, permission: 'defaultManagerRole' },
  { role: USER_ROLES.AGENT, permission: 'defaultAgentRole' },
  { role: USER_ROLES.TRADER, permission: 'defaultTraderRole' },
  { role: USER_ROLES.TECH_SUPPORT, permission: 'defaultTechSupportRole' },
  { role: USER_ROLES.PLAYER, permission: 'defaultPlayerRole' },
];

export const CURRENCY_OPTIONS = [
  { value: 'EUR', label: 'EUR' }, // TODO: Replace with actual currency options when we implement this feature
];

export const ROLE_OPTIONS_CONFIG: Partial<Record<UserRole, SelectOption[]>> = {
  [USER_ROLES.ADMIN]: [
    { value: USER_ROLES.MANAGER, label: USER_ROLES.MANAGER },
    { value: USER_ROLES.AGENT, label: USER_ROLES.AGENT },
  ],
  [USER_ROLES.MANAGER]: [{ value: USER_ROLES.AGENT, label: USER_ROLES.AGENT }],
};
